import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { LOCALES } from '../../../../constans/constans';
import English from '../../../../lang/en-US.json';
import Spanish from '../../../../lang/es-ES.json';
import France from '../../../../lang/fr-FR.json';
import { appStore } from '../../../../state/app';

const SettingLanguageCard = ({ language, description, active, onClick }) => (
  <div
    className={`settings-language-card ${active ? 'active' : ''}`}
    onClick={onClick}
  >
    <div className="settings-language-card-header">
      <span>{language}</span>
      <div className={`checkmark-wrapper ${active ? 'active' : ''}`}>{active && <span className="checkmark">✓</span>}</div>
    </div>
    <p className="settings-language-card-description">{description}</p>
  </div>
);

const Language = () => {
  const translate = useIntl();
  const { state, update } = useContext(appStore);
  const { app: { locales } } = state;
  const selectLanguage = (value) => {
    const newLocale = value;
    update('app.locales', newLocale);
    localStorage.setItem('locales', newLocale);

    switch (newLocale) {
      case LOCALES.ENGLISH.value:
        update('app.messages', English);
        break;
      case LOCALES.SPANISH.value:
        update('app.messages', Spanish);
        break;
      case LOCALES.FRENCH.value:
        update('app.messages', France);
        break;
      default:
        update('app.messages', English);
        break;
    }
  };
  return (
    <div className="settings-language">
      <div className="settings-language-title">{translate.formatMessage({ id: 'settings.tab2.title' })}</div>
      <div className="settings-language-selector">
        <SettingLanguageCard
          language={translate.formatMessage({ id: 'settings.tab2.block1' })}
          description={translate.formatMessage({ id: 'settings.tab2.block1.subtitle' })}
          active={locales === 'en-US'}
          onClick={() => selectLanguage('en-US')}
        />
        <SettingLanguageCard
          language={translate.formatMessage({ id: 'settings.tab2.block2' })}
          description={translate.formatMessage({ id: 'settings.tab2.block2.subtitle' })}
          active={locales === 'es-ES'}
          onClick={() => selectLanguage('es-ES')}
        />
        <SettingLanguageCard
          language={translate.formatMessage({ id: 'settings.tab2.block3' })}
          description={translate.formatMessage({ id: 'settings.tab2.block3.subtitle' })}
          active={locales === 'fr-FR'}
          onClick={() => selectLanguage('fr-FR')}
        />
      </div>
    </div>
  );
};

export default Language;
